import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';

import { fetchFeedGroup, getGroupFeed, getGroupPendingFeed } from 'mewe/fetchers/fetch-feed';

export let GroupFeedIndexRouteBase = {
  theme: 'group',

  queryParams: {
    tag: {
      refreshModel: true,
    },
  },

  model(params, transition) {
    let group = this.modelFor('app.group').group;
    let groupId = this.paramsFor('app.group').group_id;
    let fetchPending = !group || group.isConfirmed === true;
    let { to: toRouteInfo } = transition;

    this.tag = toRouteInfo.queryParams.tag;

    fetchFeedGroup(groupId, { hashtag: this.tag });

    this.dispatch('feed', 'dismissWrappers', { groupIds: [groupId] }, true);

    if (fetchPending) {
      getGroupPendingFeed(groupId);
    }

    let model = EmberObject.extend({
      feed: getGroupFeed(groupId),
      app: this.modelFor('app'),
      appGroup: this.modelFor('app.group'),
      tag: this.tag,
    }).create();

    return model;
  },

  // don't scroll feed when transition from pending posts feed, feed types were switched
  shouldPreventPageScroll(toRouteInfo) {
    const pendingFeedRoute = 'app.group.index.feed-pending';

    return toRouteInfo.name === pendingFeedRoute || this.routeName === pendingFeedRoute;
  },

  actions: {
    willTransition(transition) {
      let { to: toRouteInfo } = transition;

      // checking tag stored in 'this' instead controller to avoid some problems (SG-16051)
      if (this.tag) {
        this.controller.set(
          'tag',
          toRouteInfo.queryParams && toRouteInfo.queryParams.tag ? toRouteInfo.queryParams.tag : null
        );
        history.replaceState('', document.title, window.location.pathname); // prevent loading feed for tag on back navigation
      }

      if (!this.shouldPreventPageScroll(toRouteInfo)) window.scrollTo(0, 0);
    },

    refreshFeed() {
      fetchFeedGroup(this.currentModel.appGroup.groupId);
      this.currentModel.appGroup.group.newPosts = 0; // reset new posts counter and indicator
    },

    refetchFeed() {
      getGroupFeed(this.currentModel.appGroup.groupId).posts.clear();
      fetchFeedGroup(this.currentModel.appGroup.groupId);
    },
  },
};

export default Route.extend(GroupFeedIndexRouteBase);
